import { modals } from '@cad-arc';
import { useEnabledFeatures } from '../hooks/enabled-features/use-enabled-features';
import { useMutation } from '@tanstack/react-query';
import { ReactivateEventResource } from '@mark43/cad-api';
import { useApiClient } from '~/api-client';
import { FormButton, FormButtonProps } from '../../forms/integrated-form-components/form-button';
import { ReactivateClearedEventModal } from '../../event-panel/reactivate-cleared-event-modal';

export function ReactivateEventButton({
    eventId,
    size,
}: {
    eventId: number;
    size?: FormButtonProps['size'];
}) {
    const { reasonRequiredForEventReactivation } = useEnabledFeatures();
    const apiClient = useApiClient();

    const reactivateClearedEventMutation = useMutation((args: { eventId: number }) => {
        return apiClient.request<ReactivateEventResource.CadNextReactivateEvent>({
            method: 'POST',
            url: 'reactivate_event/',
            data: {
                eventId: args.eventId,
            },
        });
    });

    if (!eventId) {
        return null;
    }

    return (
        <FormButton
            size={size}
            isLoading={reactivateClearedEventMutation.isLoading}
            onClick={() => {
                if (reasonRequiredForEventReactivation) {
                    modals.blank({
                        children: ({ onClose }) => (
                            <ReactivateClearedEventModal onClose={onClose} eventId={eventId} />
                        ),
                    });
                } else {
                    reactivateClearedEventMutation.mutate({ eventId });
                }
            }}
        >
            Reactivate
        </FormButton>
    );
}
